<template>
  <!-- page-wrapper Start-->
  <div class="page-wrapper compact-wrapper" id="pageWrapper">
    <div class="page-body-wrapper">
      <div class="page-body">
        <!-- Breadcrumb & Title -->
        <div class="container-fluid">
          <div class="page-title">
            <div class="row">
              <div class="col-12 col-sm-6">
                <h3>Invoice List</h3>
              </div>
              <div class="col-12 col-sm-6">
                <ol class="breadcrumb">
                  <li class="breadcrumb-item">
                    <a class="home-item" href="/"><i data-feather="home"></i></a>
                  </li>
                  <li class="breadcrumb-item">Dashboard</li>
                  <li class="breadcrumb-item">Operation</li>
                  <li class="breadcrumb-item active">Invoice List</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <!-- Breadcrumb & Title -->

        <!-- Container-fluid starts-->
        <div class="container-fluid list-products">
          <div class="row">
            <!-- Create New -->
            <div class="col-sm-12 col-lg-12">
              <div class="card">
                <div class="card-header pb-0">
                  <h5>Filter</h5>
                </div>
                <div class="card-body">
                  <form class="needs-validation" novalidate="">
                    <div class="row g-3">
                      <div class="col-md-3">
                        <label class="form-label" for="title">Select District</label>
                        <Select2 v-model="district_id" :options="districtList" @select="mySelectDistrictEvent($event)" />
                      </div>
                      <div class="col-md-3">
                        <label class="form-label" for="name">From Date</label>
                        <input type="date" class="form-control" placeholder="Select Date" v-model="filter.from_date" />
                      </div>
                      <div class="col-md-3">
                        <label class="form-label" for="name">To Date</label>
                        <input type="date" class="form-control" placeholder="Select Date" v-model="filter.to_date" />
                      </div>
                      <div class="col-md-3">
                        <label class="form-label" for="name">Connection Type</label>
                        <select class="form-control" v-model="connectionType">
                          <option value="0" selected>All</option>
                          <option :key="tempConnectionType.id" v-for="tempConnectionType in connectionTypes"
                            :value="tempConnectionType.id">
                            {{ tempConnectionType.title }}
                          </option>
                        </select>
                      </div>
                      <div class="col-md-3">
                        <label class="form-label" for="name">Invoice Type</label>
                        <select class="form-control" v-model="invType">
                          <option value="" selected>All</option>
                          <option value="1">Manual</option>
                          <option value="2">Auto</option>
                        </select>
                      </div>
                      <div class="col-md-3">
                        <label class="form-label" for="name">Paid Status</label>
                        <select class="form-control" v-model="filter.paid_status">
                          <option value="" selected>All</option>
                          <option value="0">Unpaid</option>
                          <option value="1">Paid</option>
                        </select>
                      </div>
                    </div>
                    <button class="btn btn-primary mt-3" type="button" :disabled="!this.filter === {}"
                      @click="filterAction">
                      Search
                    </button>

                    <!-- <button class="btn btn-primary mt-3" type="button" :disabled="!this.filter === {}"
                      @click="downloadPDF3">
                      print
                    </button> -->

                    <!-- <button class="btn btn-primary mt-3" type="button" :disabled="!this.filter === {}"
                      @click="downloadPDFPaymentInvoice">
                      Payment Invoice
                    </button> -->


                  </form>
                </div>
              </div>
            </div>
            <!-- Data table -->
            <div class="col-sm-12 col-lg-12">
              <div class="card">
                <div class="card-header pb-0">
                  <h5>List</h5>
                  <span>Invoice List</span>
                  <div class="col-12 text-end">
                    <button type="button" class="btn btn-sm btn-primary" @click="downloadPDFMain()"
                      v-show="invoiceList?.length > 0">Download</button>
                  </div>
                </div>
                <div class="card-body">

                  <div class="table-responsive product-tabl">
                    <table class="display w-100" id="invoiceListTBL">
                      <thead>
                        <tr align="center">
                          <th>#</th>
                          <th>Customer Name</th>
                          <th>Mushok</th>
                          <th>Overall Due</th>
                          <th>Invoice Due</th>
                          <th>Invoice type</th>
                          <th>Sub. Total</th>
                          <th>Total</th>
                          <th>Adjustment</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr align="center" v-for="(item, index) in invoiceList" :key="index">
                          <td>{{ item.inv_no }}</td>
                          <td>
                            {{
                              customerList
                                .map((e) => e.id === item.customer_id && e.name)
                                .filter(Boolean)
                                .toString()
                            }}
                          </td>
                          <td>{{ item.mushok_no }}</td>
                          <td>{{ parseInt(item.overall_due_amount) }}</td>
                          <td>{{ parseInt(item.inv_due_amount) }}</td>
                          <td>{{ item.inv_type == 1 ? "Manual" : "Automatic" }}</td>
                          <td>{{ parseInt(item.sub_total_price) }}</td>
                          <td>{{ parseInt(item.total_price) }}</td>
                          <td>{{ parseInt(item.adjustment_amount) }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>




<script>
import "jquery/dist/jquery.min.js";
import "bootstrap/dist/css/bootstrap.min.css";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import $ from "jquery";
import invoiceAPI from "../../services/invoice.API";
import jsPDF from "jspdf";
import "jspdf-autotable";
import Moment from "moment";
import customerAPI from "../../services/customer.API";
import moment from "moment";
import Select2 from "vue3-select2-component";
import areaRelatedAPI from '../../services/areaRelatedAPI';
import connectionTypeAPI from "../../services/connectionType.API";


export default {
  name: "InvoiceListByDistrict",
  components: {
    Select2,
  },
  data() {
    return {
      ones: ["", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine"],
      tens: [
        "",
        "",
        "twenty",
        "thirty",
        "forty",
        "fifty",
        "sixty",
        "seventy",
        "eighty",
        "ninety",
      ],
      teens: [
        "ten",
        "eleven",
        "twelve",
        "thirteen",
        "fourteen",
        "fifteen",
        "sixteen",
        "seventeen",
        "eighteen",
        "nineteen",
      ],
      filter: {
        customer_id: "",
        from_date: moment(new Date()).format("yyyy-MM-DD"),
        to_date: moment(new Date()).format("yyyy-MM-DD"),
        paid_status: "",
      },
      finalInvoiceIdForPrint: [],
      customerList: [],
      selectedItem: [],
      title: "",
      price: "",
      invoiceList: [],
      districtList: [],
      isCreate: true,
      update: {
        id: "",
        title: "",
        // active_status: '',
      },
      selectedDistrict: null,
      selectedPaymentStatus: null,
      itemData: [],
      printedArray: [],
      printedHeaderOBJ: {},
      connectionTypes: [],
      connectionType: "0",
      invType: "",
    };
  },
  methods: {
    mySelectDistrictEvent({ id }) {
      this.district_id = id;
    },
    selectedAction(item) {
      this.selectedItem = item.map((e) => {
        return {
          ...e,
          bill_from_date: Moment(e.bill_from_date).format("DD-MM-YYYY"),
          bill_to_date: Moment(e.bill_to_date).format("DD-MM-YYYY"),
          initial_date: Moment(e.initial_date).format("DD-MM-YYYY"),
        };
      });
    },
    // select status
    selectStatus(e) {
      this.selectedPaymentStatus = Number(e.target.value);
      console.log(this.selectedPaymentStatus);
    },
    // sort price list
    sortPaymentList() {
      //   if (this.selectedPaymentStatus) {
      console.log(this.selectedPaymentStatus);
      if (this.selectedPaymentStatus === 1) {
        invoiceAPI.getPaidList().then(
          (response) => {
            this.invoiceList = response.data.data;
          },
          (err) => {
            this.$moshaToast(err.response.data.message, {
              type: "danger",
              position: "top-right",
              showIcon: true,
            });
          }
        );
      } else if (this.selectedPaymentStatus === 0) {
        {
          invoiceAPI.getUnpaidList().then(
            (response) => {
              this.invoiceList = response.data.data;
            },
            (err) => {
              this.$moshaToast(err.response.data.message, {
                type: "danger",
                position: "top-right",
                showIcon: true,
              });
            }
          );
        }
      } else {
        console.log("no select status");
      }
      //   }
    },
    // delete
    deleteType(id) {
      if (id) {
        invoiceAPI.deleteInvoice(id).then(
          (response) => {
            this.$moshaToast(response.data.message, {
              type: "success",
              position: "top-right",
              showIcon: true,
            });
            // get list
            if (this.selectedPaymentStatus === 1) {
              invoiceAPI.getPaidList().then(
                (response) => {
                  this.invoiceList = response.data.data;
                },
                (err) => {
                  this.$moshaToast(err.response.data.message, {
                    type: "danger",
                    position: "top-right",
                    showIcon: true,
                  });
                }
              );
            } else if (this.selectedPaymentStatus === 0) {
              {
                invoiceAPI.getUnpaidList().then(
                  (response) => {
                    this.invoiceList = response.data.data;
                  },
                  (err) => {
                    this.$moshaToast(err.response.data.message, {
                      type: "danger",
                      position: "top-right",
                      showIcon: true,
                    });
                  }
                );
              }
            } else {
              invoiceAPI.invoiceList().then(
                (response) => {
                  this.invoiceList = response.data.data;
                },
                (err) => {
                  this.$moshaToast(err.response.data.message, {
                    type: "danger",
                    position: "top-right",
                    showIcon: true,
                  });
                }
              );
            }
          },
          (err) => {
            this.$moshaToast(err.response.data.message, {
              type: "danger",
              position: "top-right",
              showIcon: true,
            });
          }
        );
      } else {
        this.$moshaToast("Please select invoice", {
          type: "danger",
          position: "top-right",
          showIcon: true,
        });
      }
    },

    downloadPDFMain() {
      // console.log("come downloadPDFMain-----------");
      let ids = this.finalInvoiceIdForPrint;
      // console.log(" -ids ---");
      // console.log(ids);
      invoiceAPI.getDetailsList(ids).then((res) => {
        console.log(res.data.data);
        if (res?.data?.data) {
          try {
            this.downloadMushokPDF2(res?.data?.mushok_file_info?.file_name_with_location);
          } catch (error) { console.log("mushok not print") }


          this.downloadPDF2(res?.data?.data);
        }
      });
    },

    downloadMushokPDF2(nameWithUrl = "#") {
      try {
        window.open(nameWithUrl, "_blank");
      } catch (e) {
        console.log(e);
      }
    },

    // download pdf
    downloadPDF(itemData) {
      console.log(itemData);
      invoiceAPI.getDetails(itemData.id).then((res) => {
        if (res?.data?.printedDate) {
          this.downloadPDF2(res?.data?.printedDate);
        }
      });
      // if (itemData) {
      //   const unit = "pt";
      //   const size = "A4"; // Use A1, A2, A3 or A4
      //   const orientation = "portrait"; // portrait or landscape

      //   // header/body data
      //   const columns = [
      //     [
      //       "#",
      //       "Bill from date",
      //       "Bill to date",
      //       "Initial date",
      //       "Note",
      //       "Price",
      //       "Year",
      //     ],
      //   ];
      //   const data = itemData.items.map((e, i) => [
      //     i + 1,
      //     Moment(e.bill_from_date).format("DD-MM-YYYY"),
      //     Moment(e.bill_to_date).format("DD-MM-YYYY"),
      //     Moment(e.initial_date).format("DD-MM-YYYY"),
      //     e.note,
      //     parseInt(e.price),
      //     e.year,
      //   ]);

      //   // alignment
      //   const marginLeft = 40;
      //   const doc = new jsPDF(orientation, unit, size);
      //   // new line
      //   // var pageWidth = doc.internal.pageSize.width || doc.internal.pageSize.getWidth();
      //   doc.setFontSize(13);

      //   doc.text("#" + itemData.inv_no, 40, 85);
      //   doc.setFontSize(10);

      //   doc.text("Mushok Number : " + itemData.mushok_no, 40, 105);
      //   doc.text("Mushok : " + parseInt(itemData.mushok), 40, 125);
      //   if (itemData.paid_status === 0) {
      //     doc.text("Payment Status : Unpaid", 40, 145);
      //   } else {
      //     doc.text("Payment Status : Paid", 40, 145);
      //   }
      //   doc.text("Sub-Total : " + parseInt(itemData.sub_total_price), 40, 165);
      //   doc.text("Total : " + parseInt(itemData.total_price), 40, 185);
      //   doc.setFontSize(15);
      //   var startingPage = doc.internal.getCurrentPageInfo().pageNumber;
      //   const title = "Report";

      //   let content = {
      //     startY: 220,
      //     head: columns,
      //     body: data,
      //     margin: {
      //       bottom: 120,
      //       top: 150,
      //     },
      //   };

      //   doc.setFont("helvetica", "bold");
      //   doc.setFontSize(15);
      //   doc.text(title, marginLeft, 50);

      //   doc.autoTable(content);

      //   doc.setPage(startingPage);
      //   doc.save("Invoice_Report(" + Moment(new Date()).format("YYYY-MM-DD") + ").pdf"); // Auto print code
      //   doc.autoPrint();
      // }
    },
    setPrintTableFromArray(doc = undefined, commonInfoBox = []) {
      doc.setLineWidth(1.3);

      for (let i = 0; i < commonInfoBox.length; i++) {
        if (Object.prototype.hasOwnProperty.call(commonInfoBox[i], "table")) {
          doc.rect(
            commonInfoBox[i].table[0],
            commonInfoBox[i].table[1],
            commonInfoBox[i].table[2],
            commonInfoBox[i].table[3]
          );
        }

        if (Object.prototype.hasOwnProperty.call(commonInfoBox[i], "line")) {
          doc.line(
            commonInfoBox[i].line[0],
            commonInfoBox[i].line[1],
            commonInfoBox[i].line[2],
            commonInfoBox[i].line[3]
          );
        }

        if (Object.prototype.hasOwnProperty.call(commonInfoBox[i], "header")) {
          this.setPrintText(
            doc,
            commonInfoBox[i].header.text,
            commonInfoBox[i].header.widthPosition,
            commonInfoBox[i].header.heightPosition + 105,
            commonInfoBox[i].header.fontStyle,
            commonInfoBox[i].header.fontSize
          );
        }

        if (Object.prototype.hasOwnProperty.call(commonInfoBox[i], "value")) {
          this.setPrintText(
            doc,
            commonInfoBox[i].value.text,
            commonInfoBox[i].value.widthPosition,
            commonInfoBox[i].value.heightPosition + 105,
            commonInfoBox[i].value.fontStyle,
            commonInfoBox[i].value.fontSize
          );
        }
      }
    },

    setPrintText(
      doc = undefined,
      text = "",
      widthPosition = 0,
      heightPosition = 0,
      fontStyle = undefined,
      fontSize = undefined,
      align = "center"
    ) {
      if (doc !== undefined) {
        // if (fontSize !== undefined) {
        //   doc.setFontSize(fontSize);
        // }

        // if (fontStyle !== undefined) {
        //   doc.setFontStyle(fontStyle);
        // }

        fontStyle = fontSize;
        fontSize = fontStyle;

        doc.setFontSize(10);

        if (align == "left") {
          doc.text(text, widthPosition, heightPosition, { align: "left" });
        } else {
          doc.text(text, widthPosition, heightPosition, { align: "center" });
        }
      }
    },



    // download pdf
    downloadPDF2(printDataList = []) {
      console.log(" ---- printDataList -------");
      console.log(printDataList);

      var doc = new jsPDF("p", "pt", "a4", true);
      var pageWidth = doc.internal.pageSize.width || doc.internal.pageSize.getWidth();
      var pageHeight = doc.internal.pageSize.height || doc.internal.pageSize.getHeight();


      for (let indexPrintDataList = 0; indexPrintDataList < printDataList.length; indexPrintDataList++) {
        let printData = printDataList[indexPrintDataList];

        const columns = [
          { title: "Item", dataKey: "service_name" },
          { title: "Description Of Service", dataKey: "details" },
          { title: "BW (MB)", dataKey: "bw" },
          { title: "Total Amount", dataKey: "price" },
        ];

        let printedArray = printData.items == undefined ? [] : printData.items;

        //  position related related info
        let userInfoBox = [
          { widthPosition: 15, heightPosition: 60, fontStyle: "bold", fontSize: 10 },
          { widthPosition: 100, heightPosition: 60, fontStyle: "normal", fontSize: 10 },
        ];

        let invoiceInfoBox = [
          { widthPosition: 345, heightPosition: 60, fontStyle: "bold", fontSize: 10 },
          { widthPosition: 450, heightPosition: 60, fontStyle: "normal", fontSize: 10 },
        ];

        let commonInfoBox = [
          {
            table: [10, 150, 100, 30], //  start width, start height,  box width, box height
            line: [11, 165, 110, 165], //  start width, start height,  end width, end height
            header: {
              text: "INFOCOM Bin No",
              widthPosition: 58,
              heightPosition: 55,
              fontStyle: "bold",
              fontSize: 10,
            },
            value: {
              text: "000479163-0505",
              widthPosition: 58,
              heightPosition: 70,
              fontStyle: "normal",
              fontSize: 10,
            },
          },
          {
            table: [130, 150, 100, 30], //  start width, start height,  box width, box height
            line: [130, 165, 230, 165], //  start width, start height,  end width, end height
            header: {
              text: "Customer Bin No",
              widthPosition: 180,
              heightPosition: 55,
              fontStyle: "bold",
              fontSize: 10,
            },
            value: {
              text: printData.customer_bin_no,
              widthPosition: 170,
              heightPosition: 70,
              fontStyle: "normal",
              fontSize: 10,
            },
          },
          {
            table: [10, 185, 100, 30], //  start width, start height,  box width, box height
            line: [11, 200, 110, 200], //  start width, start height,  end width, end height
            header: {
              text: "Previous Balance",
              widthPosition: 58,
              heightPosition: 90,
              fontStyle: "bold",
              fontSize: 10,
            },
            value: {
              text: parseInt(printData.previous_balance).toString(),
              widthPosition: 50,
              heightPosition: 105,
              fontStyle: "normal",
              fontSize: 10,
            },
          },
          {
            table: [130, 185, 100, 30], //  start width, start height,  box width, box height
            line: [130, 200, 230, 200], //  start width, start height,  end width, end height
            header: {
              text: "Payments",
              widthPosition: 175,
              heightPosition: 90,
              fontStyle: "bold",
              fontSize: 10,
            },
            value: {
              text: printData.payment,
              widthPosition: 150,
              heightPosition: 105,
              fontStyle: "normal",
              fontSize: 10,
            },
          },
          {
            table: [250, 185, 100, 30], //  start width, start height,  box width, box height
            line: [250, 200, 350, 200], //  start width, start height,  end width, end height
            header: {
              text: "Adjustments",
              widthPosition: 298,
              heightPosition: 90,
              fontStyle: "bold",
              fontSize: 10,
            },
            value: {
              text: parseInt(printData.adjustment).toString(),
              widthPosition: 295,
              heightPosition: 105,
              fontStyle: "normal",
              fontSize: 10,
            },
          },
          {
            table: [370, 185, 100, 30], //  start width, start height,  box width, box height
            line: [370, 200, 470, 200], //  start width, start height,  end width, end height
            header: {
              text: "Current Changes",
              widthPosition: 420,
              heightPosition: 90,
              fontStyle: "bold",
              fontSize: 10,
            },
            value: {
              text: parseInt(printData.current_charge).toString(),
              widthPosition: 415,
              heightPosition: 105,
              fontStyle: "normal",
              fontSize: 10,
            },
          },
          {
            table: [490, 185, 100, 30], //  start width, start height,  box width, box height
            line: [490, 200, 590, 200], //  start width, start height,  end width, end height
            header: {
              text: "Amount Due",
              widthPosition: 540,
              heightPosition: 90,
              fontStyle: "bold",
              fontSize: 10,
            },
            value: {
              text: parseInt(printData.due_amount).toString(),
              widthPosition: 530,
              heightPosition: 105,
              fontStyle: "normal",
              fontSize: 10,
            },
          },
          {
            header: {
              text: "PREPAID INTERNET BIL",
              widthPosition: 420,
              heightPosition: 70,
              fontStyle: "bold",
              fontSize: 10,
            },
          },
          {
            header: {
              // text: "Payment received after 31-Aug-2020 shall be reflected in next bill",
              text: printData.warning_message,
              widthPosition: 430,
              heightPosition: 130,
              fontStyle: "normal",
              fontSize: 9,
            },
          },
          {
            header: {
              text: "Summary Of Current Charges",
              widthPosition: 80,
              heightPosition: 130,
              fontStyle: "bold",
              fontSize: 9,
            },
          },
          // {
          //   header: {
          //     text:
          //       "In Words (BDT): " +
          //       printData.total_due_amount_in_word +
          //       " taka only.",
          //     widthPosition: 150,
          //     heightPosition: 393,
          //     fontStyle: "bold",
          //     fontSize: 10,
          //   },
          // },
          {
            header: {
              text: "Notes:",
              widthPosition: 30,
              heightPosition: 415,
              fontStyle: "bold",
              fontSize: 10,
            },
          },
          {
            header: {
              text:
                " 1. For Cash/Advance payment please pay at" +
                // printData.customer_company_name !== '' ? printData.customer_company_name : 'our' +
                " office from 9.00 AM to 5.30 PM",
              widthPosition: 182,
              heightPosition: 425,
              fontStyle: "normal",
              fontSize: 8,
            },
            /*  value: {
                text: "    at " + printData.customer_address,
                widthPosition: 140,
                heightPosition: 435,
                fontStyle: "normal",
                fontSize: 8,
              },  */
          },
          {
            value: {
              text: "2. Please pay within 10th (date) of current month and enjoy uninterrupted service",
              widthPosition: 194,
              heightPosition: 435,
              fontStyle: "bold",
              fontSize: 8,
            },
          },
          {
            value: {
              text: " 3. Mode of Payment: A/C payee Cheque / PO / Cash or by bKash:",
              widthPosition: 160,
              heightPosition: 445,
              fontStyle: "normal",
              fontSize: 8,
            },
          },
          {
            value: {
              text: "4: Eastern Bank Limited, 100 Gulshan Avenue",
              widthPosition: 118,
              heightPosition: 455,
              fontStyle: "normal",
              fontSize: 8,
            },
          },

          {
            value: {
              text: "Account Name: INFOCOM LIMITED,   Account Number: 1041060002322",
              widthPosition: 185,
              heightPosition: 470,
              fontStyle: "normal",
              fontSize: 8,
            },
          },

          {
            value: {
              text: "Swift Code: EBLDBDDH, Routing No: 095261720",
              widthPosition: 136,
              heightPosition: 480,
              fontStyle: "normal",
              fontSize: 8,
            },
          },

          {
          value: {
            text: "5: " + printData.bkash_info + " Marchant A/C ",
            widthPosition: 108,
            heightPosition: 495,
            fontStyle: "normal",
            fontSize: 8,
          },
        },

        {
          value: {
            text: "5: " + printData.bkash_info + " Marchant A/C ",
            widthPosition: 108,
            heightPosition: 495,
            fontStyle: "normal",
            fontSize: 8,
          },
        }


        ];




        // var tableHight = 0;

        doc.setFontSize(16);
        // doc.text("Invoice", 260, 25, { align: 'right' });

        this.setPrintText(doc, "Invoice", 260, 25, "bold", 56); // Invoice Text
        this.setPrintText(doc, "Issued To", 30, 45, "bold", 10); // Issued To Text

        var img = new Image();
        img.src = 'images/sample.png';
        doc.addImage(img, 'png', pageWidth - 100, 10, 80, 35);

        doc.rect(10, 50, 280, 80);

        // Name Text
        this.setPrintText(
          doc,
          "Name:",
          15,
          userInfoBox[0].heightPosition,
          userInfoBox[0].fontStyle,
          userInfoBox[0].fontSize,
          "left"
        );

        this.setPrintText(
          doc,
          printData.customer_name,
          90,
          userInfoBox[1].heightPosition,
          userInfoBox[1].fontStyle,
          userInfoBox[1].fontSize,
          "left"
        );

        // Designation Text
        this.setPrintText(
          doc,
          "Designation:",
          15,
          userInfoBox[0].heightPosition + 15,
          userInfoBox[0].fontStyle,
          userInfoBox[0].fontSize,
          "left"
        );
        this.setPrintText(
          doc,
          printData.customer_designation,
          90,
          userInfoBox[1].heightPosition + 15,
          userInfoBox[1].fontStyle,
          userInfoBox[1].fontSize,
          "left"
        );

        // Company Text
        this.setPrintText(
          doc,
          "Company:",
          15,
          userInfoBox[0].heightPosition + 30,
          userInfoBox[0].fontStyle,
          userInfoBox[0].fontSize,
          "left"
        );
        this.setPrintText(
          doc,
          printData.customer_company_name,
          90,
          userInfoBox[1].heightPosition + 30,
          userInfoBox[1].fontStyle,
          userInfoBox[1].fontSize,
          "left"
        );

        // Address Text
        this.setPrintText(
          doc,
          "Address:",
          15,
          userInfoBox[0].heightPosition + 45,
          userInfoBox[0].fontStyle,
          userInfoBox[0].fontSize,
          "left"
        );
        this.setPrintText(
          doc,
          printData.customer_address,
          90,
          userInfoBox[1].heightPosition + 45,
          userInfoBox[1].fontStyle,
          userInfoBox[1].fontSize,
          "left"
        );

        // doc.setLineWidth(0.5);
        // doc.line(11, 125, 290, 125);
        // doc.setFontStyle("normal");

        // Cont. Number Text
        // this.setPrintText(
        //   doc,
        //   "Customer Bin No:", 
        //   userInfoBox[0].widthPosition + 37,
        //   userInfoBox[0].heightPosition + 75,
        //   userInfoBox[0].fontStyle,
        //   userInfoBox[0].fontSize
        // );
        // this.setPrintText(
        //   doc,
        //   printData.customer_bin_no,
        //   userInfoBox[1].widthPosition + 25,
        //   userInfoBox[0].heightPosition + 75,
        //   userInfoBox[1].fontStyle,
        //   userInfoBox[1].fontSize
        // );

        doc.rect(340, 50, 249, 80);

        // Customer Ref Text
        this.setPrintText(
          doc,
          "Customer ID: ",
          350,
          invoiceInfoBox[0].heightPosition,
          invoiceInfoBox[0].fontStyle,
          invoiceInfoBox[0].fontSize,
          "left"
        );
        this.setPrintText(
          doc,
          printData.customer_ref_id,
          435,
          invoiceInfoBox[1].heightPosition,
          invoiceInfoBox[1].fontStyle,
          invoiceInfoBox[1].fontSize,
          "left"
        );

        this.setPrintText(
        doc,
        "In Words (BDT): " + printData.total_due_amount_in_word + " taka only.",
        15,
        500,
        "bold",
        10,
        "left"
      );
      

        // P.O Ref. Text
        // this.setPrintText(
        //   doc,
        //   "P.O Ref.:",
        //   350,
        //   invoiceInfoBox[0].heightPosition + 15,
        //   invoiceInfoBox[0].fontStyle,
        //   invoiceInfoBox[0].fontSize,
        //   "left"
        // );
        // this.setPrintText(
        //   doc,
        //   "",
        //   435,
        //   invoiceInfoBox[1].heightPosition + 15,
        //   invoiceInfoBox[1].fontStyle,
        //   invoiceInfoBox[1].fontSize,
        //   "left"
        // );

        // Quotation Ref. Text
        // this.setPrintText(
        //   doc,
        //   "Quotation Ref.:",
        //   350,
        //   invoiceInfoBox[0].heightPosition + 30,
        //   invoiceInfoBox[0].fontStyle,
        //   invoiceInfoBox[0].fontSize,
        //   "left"
        // );
        // this.setPrintText(
        //   doc,
        //   "",
        //   435,
        //   invoiceInfoBox[1].heightPosition + 30,
        //   invoiceInfoBox[1].fontStyle,
        //   invoiceInfoBox[1].fontSize,
        //   "left"
        // );



        //Invoice No. Text
        this.setPrintText(
          doc,
          "Invoice No.",
          350,
          invoiceInfoBox[0].heightPosition + 15,
          invoiceInfoBox[0].fontStyle,
          invoiceInfoBox[0].fontSize,
          "left"
        );
        this.setPrintText(
          doc,
          printData.inv_no,
          435,
          invoiceInfoBox[1].heightPosition + 15,
          invoiceInfoBox[1].fontStyle,
          invoiceInfoBox[1].fontSize,
          "left"
        );

        // Issue Date Text
        this.setPrintText(
          doc,
          "Issue Date:",
          350,
          invoiceInfoBox[0].heightPosition + 30,
          invoiceInfoBox[0].fontStyle,
          invoiceInfoBox[0].fontSize,
          "left"
        );
        this.setPrintText(
          doc,
          moment(printData.issue_date).format("DD-MM-YYYY"),
          435,
          invoiceInfoBox[1].heightPosition + 30,
          invoiceInfoBox[1].fontStyle,
          invoiceInfoBox[1].fontSize,
          "left"
        );

        // Due Date. Text
        this.setPrintText(
          doc,
          "Due Date:",
          350,
          invoiceInfoBox[0].heightPosition + 45,
          invoiceInfoBox[0].fontStyle,
          invoiceInfoBox[0].fontSize,
          "left"
        );
        this.setPrintText(
          doc,
          moment(printData.issue_date).add('days', 8).format("DD-MM-YYYY"),
          435,
          invoiceInfoBox[1].heightPosition + 45,
          invoiceInfoBox[1].fontStyle,
          invoiceInfoBox[1].fontSize,
          "left"
        );

        // Billing Period Text
        this.setPrintText(
          doc,
          "Billing Period:",
          350,
          invoiceInfoBox[0].heightPosition + 60,
          invoiceInfoBox[0].fontStyle,
          invoiceInfoBox[0].fontSize,
          "left"
        );
        this.setPrintText(
          doc,
          printData.billing_period,
          435,
          invoiceInfoBox[1].heightPosition + 60,
          invoiceInfoBox[1].fontStyle,
          invoiceInfoBox[1].fontSize,
          "left"
        );


        this.setPrintText(
          doc,
          "Deposit:",
          350,
          invoiceInfoBox[0].heightPosition + 95,
          "bold",
          invoiceInfoBox[0].fontSize,
          "left"
        );
        this.setPrintText(
          doc,
          "0.00",
          invoiceInfoBox[1].widthPosition,
          invoiceInfoBox[1].heightPosition + 95,
          "bold",
          invoiceInfoBox[1].fontSize
        );

        //  Common invoice print
        this.setPrintTableFromArray(doc, commonInfoBox);

        doc.autoTable(columns, printedArray, {
          theme: "plain",
          styles: { fontSize: 10, lineColor: [0, 0, 0], lineWidth: 0.2 },
          tableWidth: pageWidth - 15,
          showHeader: "everyPage",
          avoidPageSplit: false,
          columnStyles: {
          0: { cellWidth: 180 },
          1: { cellWidth: 239 },
          2: { cellWidth: 80 },
          3: { cellWidth: 80 }
          // etc
        },
          margin: { top: 250, right: 0, left: 10 },
          // didDrawPage:  (data) {
          //   // tableHight = data.cursor.y;
          // },
        });

        // tableHight += 20;

        // Amount relater calculation

        var amoutCalculation = [
          {
            table: [10, 400, pageWidth - 200, 20], //  start width, start height,  box width, box height
            header: {
              text: "VAT 5%",
              widthPosition: pageWidth / 3 - 25,
              heightPosition: 308,
              fontStyle: "bold",
              fontSize: 10,
            },
          },
          {
            table: [10, 425, pageWidth - 200, 20], //  start width, start height,  box width, box height
            header: {
              text: "Current Invoice Amount",
              widthPosition: pageWidth / 3 - 20,
              heightPosition: 333,
              fontStyle: "bold",
              fontSize: 10,
            },
          },
          {
            table: [10, 450, pageWidth - 200, 20], //  start width, start height,  box width, box height
            header: {
              text: "Previous Balance",
              widthPosition: pageWidth / 3 - 28,
              heightPosition: 355,
              fontStyle: "bold",
              fontSize: 10,
            },
          },
          {
            table: [10, 465, pageWidth - 200, 20], //  start width, start height,  box width, box height
            header: {
              text: "Total Due Amount",
              widthPosition: pageWidth / 3 - 29,
              heightPosition: 376,
              fontStyle: "bold",
              fontSize: 10,
            },
          },
          {
            table: [pageWidth - pageWidth / 3.5, 400, 165, 20], //  start width, start height,  box width, box height
            header: {
              text: parseInt(printData.vat_5).toString(),
              widthPosition: pageWidth - 75,
              heightPosition: 308,
              fontStyle: "bold",
              fontSize: 10,
            },
          },
          {
            table: [pageWidth - pageWidth / 3.5, 425, 165, 20], //  start width, start height,  box width, box height
            header: {
              text: parseInt(printData.current_invoice_amount).toString(),
              widthPosition: pageWidth - 75,
              heightPosition: 333,
              fontStyle: "bold",
              fontSize: 10,
            },
          },
          {
            table: [pageWidth - pageWidth / 3.5, 450, 165, 20], //  start width, start height,  box width, box height
            header: {
              text: parseInt(printData.previous_amount).toString(),
              widthPosition: pageWidth - 75,
              heightPosition: 355,
              fontStyle: "bold",
              fontSize: 10,
            },
          },
          {
            table: [pageWidth - pageWidth / 3.5, 465, 165, 20], //  start width, start height,  box width, box height
            header: {
              text: parseInt(printData.total_due_amount).toString(),
              widthPosition: pageWidth - 75,
              heightPosition: 376,
              fontStyle: "bold",
              fontSize: 10,
            },
          },
        ];

        this.setPrintTableFromArray(doc, amoutCalculation);

        let tempExtraHight = 50;

        doc.setFontSize(10);
        doc.text("INFOCOM LIMITED", 40, 601 + tempExtraHight, { align: "left" });


        doc.setFontSize(8);
        doc.text("Corporate Office: Uday tower, (9th ¬floor), Plot # 57 & 57/A, Gulshan Avenue, Dhaka-1212.IP Phone: +88-9614224466.", 40, 615 + tempExtraHight, { align: "left" });
        doc.text("Cell: +88-01819412413, Tel: +88-02222299603, +88-02222292169, +88-02222287485, +88-029887485,", 40, 625 + tempExtraHight, { align: "left" });
        doc.text("Head Office: Batali Hills, Ambagan, Chattogram -4000, Tel: +88-02 333351050-51", 40, 635 + tempExtraHight, { align: "left" });
        doc.text("E-mail: info@aktelecom.net, help@aktelecom.net, Web: www.infocomltd.net", 40, 645 + tempExtraHight, { align: "left" });

        doc.setFontSize(10);
        doc.text("Connectivity", 40, 670 + tempExtraHight, { align: "left" });
        doc.text("Unified Communication", pageWidth / 3, 670 + tempExtraHight, { align: "left" });
        doc.text("Security Solutions", (pageWidth / 1.5), 670 + tempExtraHight, { align: "left" });

        doc.setFontSize(8.5);
        doc.text("ITRM", 40, 680 + tempExtraHight, { align: "left" });
        doc.text("Contact Center Solution", pageWidth / 3, 680 + tempExtraHight, { align: "left" });
        doc.text("CCTV, Archway, Intruder Alarm	", (pageWidth / 1.5), 680 + tempExtraHight, { align: "left" });

        doc.text("Cloud Services", 40, 690 + tempExtraHight, { align: "left" });
        doc.text("IPPBX Solution", pageWidth / 3, 690 + tempExtraHight, { align: "left" });
        doc.text("Centralized Video Management Systems", (pageWidth / 1.5), 690 + tempExtraHight, { align: "left" });


        doc.text("Infrastructure", 40, 700 + tempExtraHight, { align: "left" });
        doc.text("Voice Broadcasting", pageWidth / 3, 700 + tempExtraHight, { align: "left" });
        doc.text("Access Control/Attendance System", (pageWidth / 1.5), 700 + tempExtraHight, { align: "left" });

        doc.text("Application & Hosting", 40, 710 + tempExtraHight, { align: "left" });
        doc.text("Voice Conference", pageWidth / 3, 710 + tempExtraHight, { align: "left" });
        doc.text("Antivirus Solutions", (pageWidth / 1.5), 710 + tempExtraHight, { align: "left" });


        doc.text(`This is system generated invoice no signature required. Invoice Print Date: ${printData.today_now}`, pageWidth / 2, pageHeight - 10, { align: "center" });

        doc.addPage();
      }

      doc.save(`invoice-no.pdf`);

      // Auto print code
      doc.autoPrint();
      try {
        window.open(doc.output("bloburl"), "_blank");
      } catch (e) {
        console.log(e);
      }
    },
    // filter data
    filterAction() {
      console.log(this.filter, "filterData");
      let data = {
        // customer_id: this.filter.customer_id,
        district_id: Number(this.district_id),
        from_date: this.filter.from_date,
        to_date: this.filter.to_date,
        paid_status: Number(this.filter.paid_status),
        customer_type: this.connectionType,
        inv_type: this.invType,
      };
      invoiceAPI.searchInvoiceDistrict(data).then(
        (res) => {
          this.invoiceList = res.data.data;
          this.finalInvoiceIdForPrint = [];

          if (res?.data?.data?.length === 0) {
            this.$moshaToast("No data found", {
              type: "info",
              position: "top-right",
              showIcon: true,
            });
          } else {
            for (let index = 0; index < this.invoiceList.length; index++) {
              this.finalInvoiceIdForPrint.push(this.invoiceList[index].id);
            }
          }
        },
        (err) => {
          this.$moshaToast(err.response.data.message, {
            type: "danger",
            position: "top-right",
            showIcon: true,
          });
        }
      );
    },
    convert_millions(num) {
      if (num >= 1000000) {
        return (
          this.convert_millions(Math.floor(num / 1000000)) +
          " million " +
          this.convert_thousands(num % 1000000)
        );
      } else {
        return this.convert_thousands(num);
      }
    },

    convert_thousands(num) {
      if (num >= 1000) {
        return (
          this.convert_hundreds(Math.floor(num / 1000)) +
          " thousand " +
          this.convert_hundreds(num % 1000)
        );
      } else {
        return this.convert_hundreds(num);
      }
    },
    convert_hundreds(num) {
      if (num > 99) {
        return (
          this.ones[Math.floor(num / 100)] + " hundred " + this.convert_tens(num % 100)
        );
      } else {
        return this.convert_tens(num);
      }
    },

    convert_tens(num) {
      if (num < 10) return this.ones[num];
      else if (num >= 10 && num < 20) return this.teens[num - 10];
      else {
        return this.tens[Math.floor(num / 10)] + " " + this.ones[num % 10];
      }
    },

    convert(num) {
      if (num == 0) return "zero";
      else return this.convert_millions(num);
    },

    async downloadPDF3() {


      var doc = new jsPDF("p", "pt", "a4", true);

      // doc.addFont('fonts/SolaimanLipi.ttf', 'SolaimanLipi', 'normal');
      // doc.addFileToVFS('SolaimanLipi.ttf', yanone);
      // doc.setFont('SolaimanLipi');

      // doc.addFileToVFS('SolaimanLipi.ttf', yanone);
      doc.addFont('SolaimanLipi.ttf', 'SolaimanLipi', 'normal');
      doc.setFont('SolaimanLipi');

      var pageWidth = doc.internal.pageSize.width || doc.internal.pageSize.getWidth();

      let printedArray = {
        "items": [{ "bm": "1", "service_name": "Internet", "details": "ভয়াবহ প্রাকৃতিক দুর্যোগ বলা হচ্ছে", "price": 100 }]
      };

      printedArray = printedArray.items;

      const columns = [
        { title: "ক্রমিক", dataKey: "no" },
        { title: "পন্য বা সেবার বর্ণনা", dataKey: "service_name" },
        { title: "সরবরাহের একক", dataKey: "details" },
        { title: "পরিমাণ", dataKey: "details" },
        { title: "একক মূল্য ( টাকায়)", dataKey: "price" },
        { title: "মোট মূল্য ( টাকায়)", dataKey: "price" },
        { title: "সম্পূরক শুল্কের পরিমাণ ( টাকায়)", dataKey: "price" },
        { title: "মীল্য সংযোজন কর", dataKey: "price" },
        { title: "সকল প্রকার শুল্ক ও কর সহ মূল্য ", dataKey: "price" }
      ];




      doc.setFontSize(16);

      let tempMisHight = 0;

      this.setPrintText(doc, "গণপ্রজাতন্ত্রী  বাংলাদেশ", 260, tempMisHight + 25, "normal", 56);
      this.setPrintText(doc, "জাতীয় রাজস্ত বোর্ড", 260, tempMisHight + 35, "bold", 56);
      this.setPrintText(doc, "কর চালানপত্র", 260, tempMisHight + 55, "bold", 56);

      this.setPrintText(doc, "নিবন্ধত ব্যাক্তির নাম: INFOCOM LIMITED", 260, tempMisHight + 85, "bold", 56);
      this.setPrintText(doc, "নিবন্ধিত ব্যাক্তির বিআইএন: 000479163-0505", 260, tempMisHight + 98, "bold", 56);
      this.setPrintText(doc, "চালানপত্র ইসুর ঠিকানা: Udoy Tower (9th Floor), Plot # 57 & 57 /A, Culshan-1 Dhaka-1212", 260, tempMisHight + 111, "bold", 56);


      this.setPrintText(doc, "ক্রেতার নাম", 35, tempMisHight + 135, "bold", 56);
      this.setPrintText(doc, "ক্রেতার বিআইএন", 45, tempMisHight + 150, "bold", 80);
      this.setPrintText(doc, "সরবরাহের গন্তব্যস্থল", 55, tempMisHight + 165, "bold", 56);

      this.setPrintText(doc, "চালানপত্র নম্বর", 360, tempMisHight + 135, "bold", 56);
      this.setPrintText(doc, "ইস্যুর তারিখ", 352, tempMisHight + 150, "bold", 20);
      this.setPrintText(doc, "ইস্যুর সময়", 352, tempMisHight + 165, "bold", 20);



      // this.setPrintText(doc, "", 260, 25, "bold", 56); 



      doc.autoTable(columns, printedArray, {
        lang: 'bn',
        theme: "plain",
        styles: { fontSize: 10, lineColor: [0, 0, 0], lineWidth: 0.2 },
        tableWidth: pageWidth - 15,
        showHeader: "everyPage",
        avoidPageSplit: false,
        margin: { top: 250, right: 0, left: 10 },
        // didDrawPage:  (data) {
        //   // tableHight = data.cursor.y;
        // },
      });

      // doc.addPage();

      doc.save(`bangla invoice-no.pdf`);

      // Auto print code
      doc.autoPrint();
      try {
        window.open(doc.output("bloburl"), "_blank");
      } catch (e) {
        console.log(e);
      }
    },

    async downloadPDFPaymentInvoice() {


      var doc = new jsPDF("p", "pt", "a4", true);

      doc.setFontSize(40);

      let tempMisHight = 65;
      let tempMisWidth = 40;

      // var pageHeight = doc.internal.pageSize.height || doc.internal.pageSize.getHeight();
      var pageWidth = doc.internal.pageSize.width || doc.internal.pageSize.getWidth();

      doc.setFontSize(20);
      doc.text("INFOCOM LIMITED", tempMisWidth + 260, tempMisHight + 25, { align: "center" });

      var img = new Image();
      img.src = 'images/sample.png';
      doc.addImage(img, 'png', pageWidth - 100, 30, 80, 35);

      // this.setPrintText(doc, "HEAD OFFICE: ", tempMisWidth + 100, tempMisHight + 45, "bold", 10);
      // this.setPrintText(doc, "Udoy Tower, (9th floor), Plot # 57 & 57/A, Gulshan Avenue, Dhaka 1212", tempMisWidth + 298, tempMisHight + 45, "normal", 56);
      // this.setPrintText(doc, "Tel: 88-02-9860906, 88-02-8816282, 99-028837430-33, 88-02-9892169, Cell: +88 0181941241 ", tempMisWidth + 260, tempMisHight + 58, "normal", 56);
      // this.setPrintText(doc, "E-mail: info@aktelecom.net; help@aktelecom.net; Web: www.aktelecom.net", tempMisWidth + 260, tempMisHight + 71, "normal", 56);

      doc.setFontSize(6);
      this.setPrintText(doc, "Corporate Office: Uday tower, (9th floor), Plot # 57 & 57/A, Gulshan Avenue, Dhaka-1212.IP Phone: +88-9614224466", tempMisWidth + 265, tempMisHight + 45, "bold", 10);
      this.setPrintText(doc, "Cell: +88-01819412413, Tel: +88-02222299603, +88-02222292169, +88-02222287485, +88-029887485", tempMisWidth + 270, tempMisHight + 56, "normal", 56);
      this.setPrintText(doc, "Head Office: Batali Hills, Ambagan, Chattogram -4000, Tel: +88-02 333351050-51", tempMisWidth + 260, tempMisHight + 67, "normal", 56);
      this.setPrintText(doc, "E-mail: info@aktelecom.net; help@aktelecom.net; Web: www.aktelecom.net", tempMisWidth + 260, tempMisHight + 78, "normal", 56);


      // let today = Moment(e.bill_from_date).format("DD-MM-YYYY");
      let today = Moment(new Date()).format("DD MMMM, YYYY  h:mm a");

      let data = {
        "invoice_no": "8373829",
        "customer_name": "Ashraful Islam Sheiblu",
        "mr_number": "115965",
        "mr_date": "16 july 2023",
        "received_date": "16 july, 2023",
        "amount_tk": "5400",
        "amount_tk_word": "five thousand four hundrad taka only",
        "payment_method": "bank",
        "note": "This is a note",
        "bkash_date": "16 july, 2023",
        "transection_id": "2842348234",
        "reference": "",
        "bank_name": "Estern Bank Limited",
        "bank_branch": "Mirpur pallabi dhaka",
        "cheque_number": "8494930028356465",
        "cheque_date": "16 july, 2023",
        "chalan_no": "ch032943284",
        "copy_right_message": "this invoice in automatic generate in " + today
      };

      doc.setFontSize(10);
      doc.text(`MR Number: ${data.mr_number}`, (tempMisWidth + 10), tempMisHight + 135, { align: "left" });
      doc.text(`Payment By: ${data.payment_method}`, (tempMisWidth + 10), tempMisHight + 148, { align: "left" });

      doc.setFontSize(14);
      doc.text("OFFICIAL RECEIPT", tempMisWidth + 245, tempMisHight + 140, { align: "center" });

      doc.setFontSize(10);
      doc.text(`Received Date: ${data.received_date}`, (tempMisWidth + 380), tempMisHight + 135, { align: "left" });
      doc.text(`MR Date: ${data.mr_date}`, (tempMisWidth + 380), tempMisHight + 148, { align: "left" });


      doc.text(`Amount Tk: ${data.amount_tk}`, (tempMisWidth + 10), tempMisHight + 185, { align: "left" });
      doc.text(`In Word: ${data.amount_tk_word}`, (tempMisWidth + 220), tempMisHight + 185, { align: "left" });

      // if(data.payment_method == "cash") {} else 

      if (data.payment_method == "bKash") {
        doc.text(`bKash Date: ${data.bkash_date}`, (tempMisWidth + 10), tempMisHight + 200, { align: "left" });
        doc.text(`Transection ID: ${data.transection_id}`, (tempMisWidth + 180), tempMisHight + 200, { align: "left" });
        doc.text(`Reference: ${data.reference}`, (tempMisWidth + 330), tempMisHight + 200, { align: "left" });

      } else if (data.payment_method == "chalan") {
        doc.text(`Chalan No: ${data.chalan_no}`, (tempMisWidth + 10), tempMisHight + 200, { align: "left" });

      } else if (data.payment_method == "bank") {
        doc.text(`Bank Name: ${data.bank_name}`, (tempMisWidth + 10), tempMisHight + 200, { align: "left" });
        doc.text(`Bank Branch: ${data.bank_branch}`, (tempMisWidth + 220), tempMisHight + 200, { align: "left" });
        doc.text(`Cheque No: ${data.cheque_number}`, (tempMisWidth + 10), tempMisHight + 215, { align: "left" });
        doc.text(`Cheque Date: ${data.cheque_date}`, (tempMisWidth + 220), tempMisHight + 215, { align: "left" });
      }

      doc.text(`Customer Name: ${data.customer_name}`, (tempMisWidth + 10), tempMisHight + 230, { align: "left" });
      doc.text(`This Receipt is valid only when signed by an authorized officer or a Rubber stamp.`, (tempMisWidth + 10), tempMisHight + 260, { align: "left" });
      doc.text(`Note: ${data.note}`, (tempMisWidth + 10), tempMisHight + 272, { align: "left" });
      doc.text(`Authorized Signature.`, (tempMisWidth + 395), tempMisHight + 325, { align: "center" });
      doc.text(`_____________________________`, (tempMisWidth + 315), tempMisHight + 308, { align: "left" });

      doc.text(data.copy_right_message, (tempMisWidth + 220), tempMisHight + 340, { align: "center" });

      doc.save(`Payment invoice No ${data.invoice_no}.pdf`);

      // Auto print code
      doc.autoPrint();
      try {
        window.open(doc.output("bloburl"), "_blank");
      } catch (e) {
        console.log(e);
      }
    },

  },

  mounted() {
    areaRelatedAPI.districtList().then((response) => {
      this.districtList = response.data.data?.map((e) => {
        return { ...e, text: e?.name };
      });
    });

    //   list
    invoiceAPI.invoiceList().then(
      (response) => {
        this.invoiceList = response.data.data;
        this.invoiceList = [];
        setTimeout(() => {
          $("#invoiceListTBL").DataTable({
            lengthMenu: [
              [10, 25, 50, -1],
              [10, 25, 50, "All"],
            ],
            pageLength: 10,
            info: false,
            targets: "no-sort",
            bSort: false,
            order: [],
            bFilter: true,
            bInfo: false,
            //   bLengthChange: false,
            bDestroy: true,
          });
        });
      },
      (err) => {
        this.$moshaToast(err.response.data.message, {
          type: "danger",
          position: "top-right",
          showIcon: true,
        });
      }
    );

    // emp list
    customerAPI.getList().then((response) => {
      this.customerList = response.data.data;
    });

    connectionTypeAPI.typeList().then((response) => {
      this.connectionTypes = response.data.data;
    });
  },
};
</script>

<style scoped>
.btn {
  margin: 5px;
}

th {
  text-align: center !important;
}

th,
td {
  text-align: center;
  border: 1px solid #f3f3f3;
  padding: 10px 0;
}
</style>
